import { Directive, Input, effect, inject } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { SectionsService } from '@app/shared/dasboard-sections/services/sections.service';
import { GenericApplicationSections } from '@shared/interfaces/agnostic-sections.type';

@Directive({
  selector: '[appSectionLock]',
  standalone: true,
})
export class SectionLockDirective {
  @Input('appSectionLock') section!: GenericApplicationSections;

  private readonly _sectionsService = inject(SectionsService);
  private readonly _formGroupDirective = inject(FormGroupDirective, {
    optional: false,
  });

  constructor() {
    // Make sure the service has the latest locked set at least once
    this._sectionsService.ensureLockedSectionsLoaded();
    effect(() => {
      if (!this.section) return;
      const form = this._formGroupDirective.form;
      const isLocked = this._sectionsService.isSectionLocked(this.section);
      if (isLocked) {
        form.disable({ emitEvent: false });
      }
    });
  }
}
